/**
 * HomeSLDemoPeopleDeskView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeSLDemoPeopleDesk
 */

import { useHomeSLDemoPeopleDeskLogic } from '@/hooks/traits/useHomeSLDemoPeopleDeskLogic';
import type { HomeSLDemoPeopleDeskConfig } from '@/hooks/traits/useHomeSLDemoPeopleDeskLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeSLDemoPeopleLeave } from '@app/shared';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface HomeSLDemoPeopleDeskViewProps {
  config?: Partial<HomeSLDemoPeopleDeskConfig>;
}

export function HomeSLDemoPeopleDeskView({ config: propsConfig }: HomeSLDemoPeopleDeskViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, now, config } = useHomeSLDemoPeopleDeskLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeSLDemoPeopleLeave'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return null;
}

export default HomeSLDemoPeopleDeskView;
